// Core
import React, { useState } from "react";

// Contrib
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

function Searchbar(props) {
   const [searchQuery, setSearchQuery] = useState();
   const navigate = useNavigate();

   var composeSearchQuery = (e) => {
      if (e.key === "Enter") {
         initSearch();
         return;
      }
      setSearchQuery(e.target.value);
   };

   var initSearch = function (e) {
      navigate("/search/" + searchQuery);
   };

   return (
      <div className="searchBar">
         <input type="text" name="s1" placeholder="Search for Answers" onKeyUp={composeSearchQuery} />
         <button className="btn-primary" aria-label="Left Align" onClick={initSearch}>
            <FontAwesomeIcon icon="search" style={{ color: "#fff" }} />
            Search
         </button>
      </div>
   );
}

export default Searchbar;
